import axios from 'axios';
import { SuperAdminRequest, SuperAdminResponse } from '../schemas';

export async function getAll() {
    return axios.get<SuperAdminResponse>('/v1/super-admin', {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}

export function updateSuperAdminConfig(body: SuperAdminRequest) {
    return axios.post<SuperAdminResponse>('/v1/super-admin',
        body,
        {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
            }
        }
    );
}
